import { render, staticRenderFns } from "./TimeInfo.vue?vue&type=template&id=b008a286"
import script from "./TimeInfo.vue?vue&type=script&lang=js"
export * from "./TimeInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports